module.exports = __webpack_public_path__ + "static/media/stamp.95c6dbad.svg";